// @ts-nocheck
import * as React from "react";

const CaretUp: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M16.843 13.789A.75.75 0 0 1 16.251 15H7.75a.75.75 0 0 1-.591-1.212l4.258-5.498a.746.746 0 0 1 1.183.001l4.243 5.498z"
            />
        </svg>
    );
};

export default React.memo(CaretUp);
